import type { MatrixScope } from "@app/core";

import type { SidebarPart } from "../stores/settings.store.js";

interface SidebarVisibilityInputs {
  visible: Record<SidebarPart, boolean>;
  matrixScope: MatrixScope;
  prioritiesOverride: boolean | null;
}

/** Effective navigation visibility. Priorities follows matrix scope until the
 * user explicitly overrides it; every other part uses its stored boolean. */
export function sidebarPartVisible(
  part: SidebarPart,
  inputs: SidebarVisibilityInputs,
): boolean {
  if (part !== "priorities") return inputs.visible[part];
  return inputs.prioritiesOverride ?? inputs.matrixScope !== "off";
}
